import React from "react";

export function Stepper({ step, total }) {
  return (
    <div className="stepper" data-testid="wizard-stepper">
      {Array.from({ length: total }).map((_, i) => (
        <div key={i} className="stepper-pill">
          <div className="fill" style={{ width: i < step ? "100%" : i === step - 1 ? "100%" : "0%" }}></div>
        </div>
      ))}
    </div>
  );
}
